import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) return 15 * 60; // Auto-reset
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  return <section className="bg-[#00A86B] py-8 px-4" data-id="element-48">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-50">
          <p className="text-white font-heading font-bold text-lg mb-4 tracking-wide" data-id="element-51">
            DESCUENTO SUPER ESPECIAL
          </p>

          <div className="flex justify-center items-center gap-4 mb-4" data-id="element-52">
            <div className="bg-black/20 backdrop-blur-sm rounded-xl w-20 h-20 flex flex-col items-center justify-center border border-white/10" data-id="element-53">
              <span className="text-white font-heading font-bold text-4xl leading-none" data-id="element-54">
                {minutes}
              </span>
              <span className="text-white/80 text-xs mt-1 uppercase tracking-wider" data-id="element-55">
                Min
              </span>
            </div>
            <span className="text-white font-bold text-2xl pb-4" data-id="element-56">:</span>
            <div className="bg-black/20 backdrop-blur-sm rounded-xl w-20 h-20 flex flex-col items-center justify-center border border-white/10" data-id="element-57">
              <span className="text-white font-heading font-bold text-4xl leading-none" data-id="element-58">
                {seconds}
              </span>
              <span className="text-white/80 text-xs mt-1 uppercase tracking-wider" data-id="element-59">
                Seg
              </span>
            </div>
          </div>

          <p className="text-red-100 text-sm font-medium max-w-md mx-auto" data-id="element-60">
            Reserva válida solo por 15 minutos. Si no accedés, tu descuento pasa
            a la siguiente persona.
          </p>
        </motion.div>
      </div>
    </section>;
}